import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    GET_TRAVEL_COSTS: {
        url: "vervanger/travelcost-pdf-list",
        method: "post",
    },

    GET_TRAVEL_COSTS_BY_COMMUNITY: (communityId) => ({
        url: `travelcost-list?communityId=${communityId}`,
        method: "get",
    }),

    DOWNLOAD_DOCUMENT: (id, type) => ({
        url: `document/${id}/${type}/travelcost`,
        method: "get",
    })
};

export const useTravelCosts = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_TRAVEL_COSTS);

export const useTravelCostsByCommunity = (communityId) =>
    useApiFetcherSWR(
        communityId
            ? API_ENDPOINT.GET_TRAVEL_COSTS_BY_COMMUNITY(communityId)
            : { url: null, method: "get" }
    );

export const useDownloadTravelCost = (id, type) =>
    useApiFetcherSWR(
        id && type
            ? {
                url: `document/${id}/${type}/travelcost`,
                method: "get",
            }
            : null
    );